import React from 'react';

const EmptyRoute = () => {
  return <></>;
};

export default EmptyRoute;
